import React, { useEffect, useState } from "react";
import CommonModal from "../../../components/shared/modalLayout/CommonModal";
import { Col, Row } from "react-bootstrap";
import InputWithLabel from "../../../components/shared/fields/InputWithLabel";
import InputWithIcon from "../../../components/shared/fields/InputWithIcon";
import { RefreshSvg } from "../../../svgFiles/RefreshSvg";
import Button from "../../../components/shared/buttons/button";
import SelectBox from "../../../components/shared/fields/SelectBox ";
import { useGetFruitsQuery } from "../../Receiving/unloading/unloadingApi";
import { useUpdateBrokerageMaterialMutation } from "../materialEntered/materialApi";
import toast from "react-hot-toast";
import useTranslator from "../../../hooks/useTranslator";

const BrokerageSortinModal = ({ show, setShow, unloading, mode, onSuccess }) => {
  const { _t } = useTranslator();
  const [updateRawMaterial] = useUpdateBrokerageMaterialMutation();
  const { data: fruitList } = useGetFruitsQuery();
  const initialFormData = {
    supplier_name: "",
    fruit_type_id: "",
    batch_code: "",

    total_entered_kg: "0",

    total_selected_kg: "0",

    selected_cheeks_kg: "0",

    selected_stripe_kg: "0",

    rejected_kg: "0",
    status: "",
  };
  const [formData, setFormData] = useState(initialFormData);
  useEffect(() => {
    if (mode === "edit" && unloading) {
      const updatedFormData = { ...initialFormData };

      for (const key in unloading) {
        if (key in initialFormData) {
          updatedFormData[key] = unloading[key];
        }
      }

      setFormData(updatedFormData);
    } else {
      setFormData(initialFormData);
    }
  }, [mode, unloading, show]);

  const [errors, setErrors] = useState({});
  const handleChange = (e) => {
    const { name, value } = e.target;
    const numericValue = Number(value);
    if (numericValue < 0) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: _t("value_cannot_be_negative", "Value cannot be negative"),
      }));
      return; // Stop state update
    }

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));

    const updatedFormData = { ...formData, [name]: value };

    setFormData(updatedFormData);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    const updatedFormData = { ...formData };

    if (unloading?.status === formData.status) {
      delete updatedFormData.status;
    }
    const totalEnteredKg = Number(formData.total_entered_kg || 0);
    const totalSelectedKg = Number(formData.total_selected_kg || 0);
    const rejectedKg = Number(formData.rejected_kg || 0);
    const selectedCheeksKg = Number(formData.selected_cheeks_kg || 0);
    const selectedStripsKg = Number(formData.selected_stripe_kg || 0);

    if (formData.status === "packaging") {
      if (totalEnteredKg !== totalSelectedKg + rejectedKg) {
        toast.error(
          _t(
            "total_entered_kg_validation",
            "The total entered weight doesn't add up. Total Entered KG must equal the sum of Selected KG and Rejected KG."
          )
        );
        return;
      }

      if (totalSelectedKg !== selectedCheeksKg + selectedStripsKg) {
        toast.error(
          _t(
            "total_selected_kg_validation",
            "Total Selected KG must equal Selected Cheeks KG + Selected Strips KG."
          )
        );
        return;
      }
    }

    const payload = {
      id: unloading.id,
      requestBody: updatedFormData,
    };

    try {
      await updateRawMaterial(payload).unwrap();
      onSuccess?.();
      handleClose();
    } catch (error) {
      console.error("Error creating/updating manager:", error);
    }
  };

  const handleClose = () => {
    setShow(false);
  };
  const renderFormFields = () => (
    <>
      <Col lg={6}>
        <InputWithLabel
          label={_t("brokerage_name", "Brokerage Name")}
          type="text"
          name="supplier_name"
          value={formData.supplier_name}
          disabled={true}
        />
      </Col>
      <Col lg={6}>
        <SelectBox
          label={_t("fruit_type", "Fruit Type")}
          name="fruit_type_id"
          options={fruitList?.data.map((list) => ({
            value: list.id,
            label: list.name,
          }))}
          value={formData.fruit_type_id}
          required={false}
          onChange={handleChange}
          disabled={true}
        />
      </Col>
      <Col lg={6}>
        <InputWithLabel
          label={_t("batch_code", "Batch Code")}
          type="text"
          name="batch_code"
          value={formData.batch_code}
          disabled={true}
        />
      </Col>
      <Col lg={6}>
        <InputWithLabel
          label={_t("time_date", "Time/Date")}
          type="text"
          name="batch_code"
          value={formData.batch_code}
          disabled={true}
        />
      </Col>

      <Col lg={6}>
        <InputWithLabel
          label={_t("total_entered_kg", "Total Entered KG")}
          type="number"
          name="total_entered_kg"
          value={formData.total_entered_kg}
          disabled={true}          
          placeholder={"0"}
        />
      </Col>
      <Col lg={6}>
        <InputWithIcon
          label={_t("total_selected_kg", "Total Selected KG")}          
          type="number"
          name="total_selected_kg"
          error={errors.total_selected_kg}
          onChange={handleChange}
          value={formData.total_selected_kg}
          icon={RefreshSvg}
          placeholder={"0"}
        />
      </Col>

      <Col lg={6}>
        <InputWithIcon
          label={_t("selected_cheeks_kg", "Selected Cheeks KG")}
          type="number"
          name="selected_cheeks_kg"
          value={formData.selected_cheeks_kg}
          // disabled={mode === "view"}
          error={errors.selected_cheeks_kg}
          onChange={handleChange}
          icon={RefreshSvg}
          placeholder={"0"}
          />
      </Col>

      <Col lg={6}>
        <InputWithIcon
          label={_t("selected_strips_kg", "Selected Strips KG")}
          placeholder={_t("selected_strips_kg", "Selected Strips KG")}
          type="number"
          name="selected_stripe_kg"
          value={formData.selected_stripe_kg}
          icon={RefreshSvg}
          error={errors.selected_stripe_kg}
          onChange={handleChange}
        />
      </Col>

      <Col lg={6}>
        <InputWithIcon
          label={_t("rejected_kg", "Rejected KG")}
          placeholder={_t("rejected_kg", "Rejected KG")}
          type="number"
          name="rejected_kg"
          value={formData.rejected_kg}
          icon={RefreshSvg}
          error={errors.rejected_kg}
          onChange={handleChange}
        />
      </Col>

      <Col lg={6}>
        <SelectBox
          label="Status"
          name="status"
          value={formData.status}
          options={[
            { value: "sorting", label: _t("sorting", "Sorting") },
            {
              value: "packaging",
              label: _t("ready_for_packing", "Ready For Packing"),
            },
          ]}
          onChange={handleChange}
          // disabled={mode === "view"}
        />
      </Col>
    </>
  );
  return (
    <CommonModal
      show={show}
      handleClose={handleClose}
      setShow={setShow}
      title={
        mode === "add"
          ? _t("adding_brokerage_material", "Adding Brokerage Material")
          : _t("edit_brokerage_material", "Edit Brokerage Material")
      }
    >
      <Row>{renderFormFields()}</Row>
      <Row>
        <Col className="text-end">
          <Button
            label={_t("save_changes", "Save Changes")}
            size="small"
            onClick={handleSubmit}
            // isLoading={isCreating || isUpdating}
          />
        </Col>
      </Row>
    </CommonModal>
  );
};

export default BrokerageSortinModal;
